import React from "react";
import { withRouter, Link } from "react-router-dom";
import { connect } from "react-redux";
import { Route } from "react-router";
import { Flex } from "/app/src/component";

import MainPanel from "./MainPanel";

import { Helmet } from "react-helmet";

import UserModel from "/app/src/model/User/model";
import UserSelector from "/app/src/model/User/selector";
// socket
import Spinner from "/app/src/component/Spinner";

class Dashboard extends React.Component {
  componentDidMount() {
    if (this.props.userToken) {
      let url = this.props.apiUrl;
    }
    window.addEventListener("focus", this._resetTab);
  }
  componentWillUnmount() {
    document.removeEventListener("focus", this._resetTab);
  }

  render() {
    if (this.props.fetchingData && this.props.fetchedData <= 1) {
      return (
        <Flex
          width="100%"
          height="100%"
          hAlignContent="center"
          vAlignContent="center"
        >
          <Spinner />
        </Flex>
      );
    }
    return (
      <Flex width="100%" height="100%" column>
        <Helmet>
          <meta charSet="utf-8" />
          <title> Admin Dashboard </title>
          <link rel="shortcut icon" href="/favicon.ico" />
        </Helmet>
        <Flex borderBottom="1px solid" height="70px" w="100%">
          <Link to="/">Företag</Link>
          <Link to="/discount">Rabbatkod</Link>
        </Flex>
        <Flex grow overflow="hidden" h="100%">
          <Route component={MainPanel} />
        </Flex>
      </Flex>
    );
  }
}

function mapStateToProps(state) {
  return {
    apiUrl: state.getIn(["system", "api"]),
    userToken: UserSelector.getToken(state),
    userId: UserSelector.getId(state),
    fetchingData: state.getIn(["user", "initialData", "isFetching"], false),
    fetchedData: state.getIn(["user", "initialData", "isFetched"], true),
  };
}

export default withRouter(connect(mapStateToProps)(Dashboard));



// WEBPACK FOOTER //
// src/layout/Dashboard/index.js